<template>
  <div class="editCategory">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -5px;color:rgba(52,152,219,1);"
        ></i>商品分类
      </div>
    </div>

    <div v-if="role" style="width: 1056px;margin: 0 auto">
      <div class="form-title">
        <div style="float: left;line-height: 46px;padding-left: 10px;">数据列表</div>
      </div>
      <div class="table">
        <button
          type="button"
          class="el-button el-button--text el-button--mini"
          @click="append({id:0,fid:0})"
        >
          <span>添加子分类</span>
        </button>
        <el-tree :data="array" node-key="id" accordion :expand-on-click-node="true">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span style="padding-left: 20px;">
              <el-button
                type="text"
                size="mini"
                @click="append(data)"
                v-if="data.children!=null"
              >添加子分类</el-button>
              <el-button type="text" size="mini" @click="set(data)">编辑</el-button>
              <el-button type="text" size="mini" @click="remove(data)">删除</el-button>
            </span>
          </span>
        </el-tree>
      </div>
    </div>
    <noAccess v-else></noAccess>
    <el-dialog title="添加子分类" :visible.sync="dialogVisible" width="600px">
      <el-form ref="form" label-width="80px" style="width: 400px">
        <el-form-item label="分类名称">
          <el-input v-model="cateName"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="rank"></el-input>
        </el-form-item>
        <el-form-item label="图片" v-if="addffid != '0'">
          <el-upload
            action
            list-type="picture-card"
            :on-change="handlechange"
            :auto-upload="false"
            :limit="1"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="info"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="编辑分类" :visible.sync="dialogVisible1" width="600px">
      <el-form ref="form" label-width="80px" style="width: 400px">
        <el-form-item label="分类名称">
          <el-input v-model="setName"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="rank1"></el-input>
        </el-form-item>
        <el-form-item label="图片" v-if="type == 3">
          <div style="display:flex;">
            <div v-if="setImg != ''">
              <img width="148px" height="148px" :src="serve+'' + setImg" alt />
            </div>
            <div>
              <el-upload
                ref="upload"
                action
                list-type="picture-card"
                :on-change="setchange"
                :auto-upload="false"
                :limit="1"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="submit1()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "editCategory",
  data() {
    return {
      serve: this.$store.state.serve,
      role: true,
      setImg: "",
      file: null,
      setFile: null,
      setffid: "",
      dialogImageUrl: "",
      addffid: "",
      rank1: "",
      rank: "",
      type: Number,
      cate_id: "",
      setName: "",
      dialogVisible1: false,
      dialogVisible: false,
      array: [],
      categorys: null,
      defaultProps: {
        children: "children",
        label: "label"
      },
      cateName: "",
      info: "",
      username: this.$cookies.get("username"),
      token: this.$cookies.get("token"),
      checked: false
    };
  },
  mounted() {
    //
  },
  created() {
    this.$store.state.topActiveId = 2;
    this.$store.state.leftTitle = "商品分类";
    this.geting();
  },
  methods: {
    handlechange(file, filelist) {
      this.file = file.raw;
    },
    setchange(file, filelist) {
      this.setImg = "";
      this.setFile = file.raw;
    },
    geting() {
      this.axios
        .get(this.serve + "/admin/get_category", {
          params: {
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.array = [];
            this.categorys = res.data.data;
            var i = 0;
            for (var item of this.categorys) {
              if (item.f_id == 0 && item.ff_id == 0) {
                var childrenArr = [];
                for (var sitem of this.categorys) {
                  if (sitem.f_id == item.id) {
                    var childrenArr2 = [];
                    for (var ssitem of this.categorys) {
                      if (ssitem.f_id == sitem.id) {
                        childrenArr2.push({
                          img: ssitem.cover,
                          label: ssitem.cate_name,
                          order_by: ssitem.order_by,
                          id: ssitem.id,
                          fid: ssitem.f_id,
                          ffid: ssitem.ff_id
                        });
                      }
                    }
                    childrenArr.push({
                      label: sitem.cate_name,
                      order_by: sitem.order_by,
                      id: sitem.id,
                      fid: sitem.f_id,
                      ffid: sitem.ff_id,
                      children: childrenArr2
                    });
                  }
                }
                this.array.push({
                  label: item.cate_name,
                  id: item.id,
                  fid: 0,
                  ffid: 0,
                  children: childrenArr,
                  order_by: item.order_by
                });
              }
            }
          }else if(res.data.status == 'error' && res.data.code == '403')
          {
            this.role = false
          }
        })
        .catch(error => {});
    },
    submit() {
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      this.checked = true;
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let that = this;
      // var params = {};
      var formData = new FormData();
      formData.append("cover", this.file);
      formData.append("cateName", this.cateName);
      formData.append("fid", this.fid);
      formData.append("ffid", this.ffid);
      formData.append("info", this.info);
      formData.append("username", this.username);
      formData.append("token", this.token);
      formData.append("order_by", this.rank);
      this.axios
        .post(this.serve + "/admin/add_category", formData)
        .then(function(res) {
          if (res.data.status == "success") {
            that.rank = "";
            that.cateName = "";
            that.info = "";
            that.dialogVisible = false;
            loading.close();
            that.geting();
            that.$message({
              type: "success",
              message: res.data.msg
            });
            // location.reload();
          } else if (res.data.status == "error") {
            loading.close();
            that.dialogVisible = false;
            that.$message({
              type: "error",
              message: res.data.msg
            });
            // alert(res.data.msg);
          }
        });
    },
    append(data) {
      // return
      this.dialogVisible = true;
      this.fid = data.id;
      this.ffid = data.fid;
      this.addffid = data.fid;
    },
    remove(data) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          var that = this;
          this.axios
            .get(this.serve + "/admin/delete_category", {
              params: {
                id: data.id,
                username: this.username,
                token: this.token
              }
            })
            .then(function(res) {
              if (res.data.status == "success") {
                // location.reload();
                that.$message({
                  type: "success",
                  message: "删除成功!"
                });
                that.geting();
              } else if (res.data.status == "error") {
                if(res.data.code == '403'){
                  that.$message.error(res.data.msg);  
                }else{
                    that.$message({
                    type: "error",
                    message: "删除失败!"
                    });
                    that.geting();
                }
                
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    set(data) {
      this.setImg = data.img;
      this.dialogVisible1 = true;
      this.setName = data.label;
      this.rank1 = data.order_by;
      this.cate_id = data.id;
      if (data.ffid == 0 && data.fid == 0) {
        this.type = 1;
      } else if (data.ffid == 0 && data.fid != 0) {
        this.type = 2;
      } else if (data.ffid != 0 && data.fid != 0) {
        this.type = 3;
      }
    },
    submit1() {
      const formData = new FormData();
      formData.append("username", this.username);
      formData.append("token", this.token);
      formData.append("type", this.type);
      formData.append("cate_id", this.cate_id);
      formData.append("cate_name", this.setName);
      formData.append("order_by", this.rank1);
      formData.append("cover", this.setFile);
      this.axios
        .post(this.serve + "/admin/edit_category", formData)
        .then(res => {
          if (res.data.status == "success") {
            this.$refs.upload.clearFiles();
            this.dialogVisible1 = false;
            this.geting();
            this.$message({
              type: "success",
              message: "编辑成功"
            });
          } else if (res.data.status == "error") {
            if(res.data.code == '403'){
              this.$message.error(res.data.msg);  
            }else{
              this.$message.error("编辑失败");
            }
            
          }
        });
    },
    handleNodeClick(data) {}
  }
};
</script>
<style lang="scss">
.editCategory {
  min-height: 1000px;
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  .topBar {
    margin-bottom: 40px;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
}
</style>